"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CampaignSurveyFactory = void 0;
var ISurvey = require("../Api/ISurvey");
var SurveyEvents_1 = require("../SurveyEvents");
var SurveyMetadata_1 = require("../SurveyMetadata");
var FpsSurvey = require("../Surveys/FpsSurvey");
var GenericMessagingSurfaceSurvey = require("../Surveys/GenericMessagingSurfaceSurvey");
var InterceptSurvey = require("../Surveys/InterceptSurvey");
var NlqsSurvey = require("../Surveys/NlqsSurvey");
var NpsSurvey = require("../Surveys/NpsSurvey");
var SurveyDataSource = require("../Surveys/SurveyDataSource");
var Utils = require("../Utils");
var CampaignDefinitionProvider_1 = require("./CampaignDefinitionProvider");
var dateToShortUtcString = Utils.dateToShortUtcString,
  isNOU = Utils.isNOU;
/**
 * Contains methods to take a campaign definition + state and generate an ISurvey
 */
var CampaignSurveyFactory = /** @class */function () {
  function CampaignSurveyFactory() {}
  CampaignSurveyFactory.makeSurvey = function (state, definition, stringProvider) {
    if (!state || !definition || !definition.surveyTemplate || !stringProvider) {
      return null;
    }
    var surveyDataSource = CampaignSurveyFactory.makeSurveyDataSourceData(state, definition);
    var surveyModel = definition.surveyTemplate;
    if (surveyModel instanceof CampaignDefinitionProvider_1.CampaignSurveyTemplateNps5PointStatic) {
      return NpsSurvey.make5Point(surveyDataSource, stringProvider);
    } else if (surveyModel instanceof CampaignDefinitionProvider_1.CampaignSurveyTemplateNps11PointStatic) {
      return NpsSurvey.make11Point(surveyDataSource, stringProvider);
    } else if (surveyModel instanceof CampaignDefinitionProvider_1.CampaignSurveyTemplateFps) {
      return FpsSurvey.makeFps(surveyDataSource, stringProvider, surveyModel);
    } else if (surveyModel instanceof CampaignDefinitionProvider_1.CampaignSurveyTemplateNlqs) {
      return NlqsSurvey.makeNlqs(surveyDataSource, stringProvider, surveyModel);
    } else if (surveyModel instanceof CampaignDefinitionProvider_1.CampaignSurveyTemplateNps) {
      return NpsSurvey.makeCustom(surveyDataSource, stringProvider, surveyModel);
    } else if (surveyModel instanceof CampaignDefinitionProvider_1.CampaignSurveyTemplateGenericMessagingSurface) {
      return GenericMessagingSurfaceSurvey.makeCustom(surveyDataSource);
    } else if (surveyModel instanceof CampaignDefinitionProvider_1.CampaignSurveyTemplateIntercept) {
      return InterceptSurvey.makeIntercept(surveyDataSource, stringProvider, surveyModel);
    } else {
      return null;
    }
  };
  CampaignSurveyFactory.makeSurveyDataSourceData = function (state, definition) {
    if (!state || !definition || !definition.surveyTemplate) {
      return null;
    }
    var surveyModel = definition.surveyTemplate;
    var surveyData = new SurveyDataSource.SurveyDataSourceData();
    surveyData.activationEvent = CampaignSurveyFactory.makeEvent(state, surveyModel.activationEvent);
    surveyData.metadata = CampaignSurveyFactory.makeMetadata(surveyModel.metadata);
    surveyData.id = state.LastSurveyId;
    surveyData.backEndIdentifier = state.CampaignId;
    surveyData.expirationTimeUtc = dateToShortUtcString(state.LastSurveyExpirationTimeUtc);
    surveyData.governedChannelType = definition.governedChannelType;
    surveyData.startTimeUtc = dateToShortUtcString(state.LastSurveyStartTimeUtc);
    surveyData.additionalDataRequested = definition.additionalDataRequested || [];
    surveyData.launcherType = definition.launcherType || ISurvey.LAUNCHER_TYPE_DEFAULT;
    surveyData.businessLevel = definition.businessLevel;
    if (!isNOU(surveyModel.maxLaunches)) {
      surveyData.maxLaunches = surveyModel.maxLaunches;
    }
    if (!isNOU(surveyModel.maxLaunchesPerSession)) {
      surveyData.maxLaunchesPerSession = surveyModel.maxLaunchesPerSession;
    }
    return surveyData;
  };
  CampaignSurveyFactory.makeCountedActivityEventData = function (eventModel) {
    if (!eventModel) {
      return null;
    }
    var eventData = new SurveyEvents_1.CountedActivityEventData();
    eventData.activity = eventModel.activity;
    eventData.count = eventModel.count;
    eventData.isAggregate = eventModel.isAggregate;
    return eventData;
  };
  CampaignSurveyFactory.makeCountedActivityEvent = function (state, eventModel) {
    if (!state || !eventModel) {
      return null;
    }
    var eventData = CampaignSurveyFactory.makeCountedActivityEventData(eventModel);
    if (!eventData) {
      return null;
    }
    return new SurveyEvents_1.CountedActivityEvent(eventData);
  };
  CampaignSurveyFactory.makeCountedActivitySequenceEvent = function (state, eventModel) {
    if (!state || !eventModel) {
      return null;
    }
    var sequenceEventData = new SurveyEvents_1.CountedActivitySequenceEventData();
    sequenceEventData.sequence = [];
    for (var _i = 0, _a = eventModel.sequence; _i < _a.length; _i++) {
      var event_1 = _a[_i];
      var eventData = CampaignSurveyFactory.makeCountedActivityEventData(event_1);
      if (!eventData) {
        return null;
      }
      sequenceEventData.sequence.push(eventData);
    }
    return new SurveyEvents_1.CountedActivitySequenceEvent(sequenceEventData);
  };
  CampaignSurveyFactory.makeEvent = function (state, eventModel) {
    if (eventModel instanceof CampaignDefinitionProvider_1.CampaignSurveyEventCountedActivity) {
      return CampaignSurveyFactory.makeCountedActivityEvent(state, eventModel);
    } else if (eventModel instanceof CampaignDefinitionProvider_1.CampaignSurveyEventCountedActivitySequence) {
      return CampaignSurveyFactory.makeCountedActivitySequenceEvent(state, eventModel);
    } else {
      return null;
    }
  };
  CampaignSurveyFactory.makeMetadata = function (metadataModel) {
    if (isNOU(metadataModel) || isNOU(metadataModel.contentMetadata)) {
      return null;
    }
    var metadata = new SurveyMetadata_1.Metadata();
    metadata.contentMetadata = metadataModel.contentMetadata;
    return new SurveyMetadata_1.SurveyMetadata(metadata);
  };
  return CampaignSurveyFactory;
}();
exports.CampaignSurveyFactory = CampaignSurveyFactory;